import { render, staticRenderFns } from "./Prefixes.vue?vue&type=template&id=3c4e577a&"
import script from "./Prefixes.vue?vue&type=script&lang=js&"
export * from "./Prefixes.vue?vue&type=script&lang=js&"
import style0 from "./Prefixes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports